import { render, staticRenderFns } from "./ApiMarket.vue?vue&type=template&id=826c4b90&scoped=true"
import script from "./ApiMarket.vue?vue&type=script&lang=js"
export * from "./ApiMarket.vue?vue&type=script&lang=js"
import style0 from "./ApiMarket.vue?vue&type=style&index=0&id=826c4b90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826c4b90",
  null
  
)

export default component.exports